import React, { Component } from 'react';

class SimpleSliderDruckfarbe extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state ={
      valueLeft:0,
      valueRight:0,
      leftLabel: `${this.props.white}+cmyk`,
      rightLabel: "cmyk",
      overrideLabels: false
    }
    this.transformed = false;
  }

  handleChange(e) {
    const value = e.target.value;
    this.props.onChange(value);
    this.setLabels(value)
  }

  setLabels = (value) => {
    if(value <= 0 && !this.state.overrideLabels){
      this.setState({
        leftLabel: this.props.white
      })
    }
    else if(value > 0 && value < 100 && this.state.leftLabel !== `${this.props.white}+cmyk` && !this.state.overrideLabels){
      this.setState({
        leftLabel: `${this.props.white}+cmyk`
      })
    }
    if(this.state.rightLabel !== "cmyk" && !this.state.overrideLabels){
      this.setState({
        rightLabel: "cmyk"
      })
    }
  }
  
  componentDidMount = () => {
    const value = this.props.defaultValue;
    this.props.onChange(value)
  }

  componentDidUpdate = () => {
    if(this.props.textilePercentage >= 51 && !this.state.overrideLabels){
      this.setState({
        overrideLabels: true
      }, () => {
        this.setState({
          rightLabel: `cmyk+${this.props.white}`,
          leftLabel: `${this.props.white}`
        })
      })
    }
    else if(this.props.textilePercentage <= 50 && this.state.overrideLabels){
      this.setState({
        overrideLabels: false
      }, () => {
        this.setLabels(this.props.defaultValue)
      })
    }
    else if(this.props.textilePercentage <= 50 && !this.state.overrideLabels && this.state.leftLabel !== `${this.props.white}`){
      this.setLabels(this.props.defaultValue)
    }
    else if(this.props.textilePercentage <= 50 && !this.state.overrideLabels && this.props.defaultValue > 0 && this.state.leftLabel !== `${this.props.white}+cmyk`){
      this.setLabels(this.props.defaultValue)
    }
  }

  render() {
    const styles = this.props.styles
    const icon = this.props.icon
    return(
      <div>
        <div className={styles.row}>
            <div className={styles.icon}>
              <img src={icon} alt="" />
            </div>
            <div className={styles.slider}>
              <aside className={styles.sliderData}>
                <span>{100 - this.props.defaultValue}{this.props.showPercentage && "%"}</span>
                <span>{this.props.defaultValue}{this.props.showPercentage && "%"}</span>
              </aside>
              <input onChange={this.handleChange} type="range"
                name={this.props.name}
                value={this.props.defaultValue}
                max="100"
                min="0"
                step="1"
              />
              <aside>
                <span>{this.state.leftLabel}</span>
                <span className={styles.bottom}>{this.props.label}</span>
                <span>{this.state.rightLabel}</span>
              </aside>
            </div>
          </div>
      </div>
      
    );
  }
}

export default SimpleSliderDruckfarbe;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_slider_druckfarbe.js